
const COMPANY_MENU_TRANSITION = {
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    }
}
export default COMPANY_MENU_TRANSITION